import { Component, OnInit } from '@angular/core';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { Branch } from '../../../shared/models/missingdata.model';
import { BranchService } from '../../../shared/_services/branch.service';

@Component({
  selector: 'app-table-branches',
  templateUrl: './table-branches.component.html',
  styleUrls: ['../admin-tables.component.css'],
  animations: [
    trigger('EnterLeave', [
      state('flyin', style({
        opacity: 1,
        transform: 'translateX(0%)'
      })),
      transition(':enter', [
        style({
          opacity: 0.2,
          transform: 'translateX(-100%)',
        }),
        animate('0.3s 300ms ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          transform: 'translateX(100%)'
        }))
      ])
    ])
  ]
})
export class TableBranchesComponent implements OnInit {


  SearchTerm: string;
  List: Branch[];
  NewElement: Branch;
  saveElement: Branch[] = [];
  FormNew = false;
  error: string;
  message: string;

  constructor(
    private branchService: BranchService
  ) { }

  ngOnInit() {

    this.branchService.getBranches()
      .subscribe((lista: Branch[]) => {
        this.List = lista;
      }, err => console.log(err))

  }

  cleanMessage() {
    this.message = undefined;
    this.error = undefined;
    this.saveElement = [];
  }

  onKeyUp(value) {
    this.SearchTerm = value;
  }

  toggleNew() {
    this.NewElement = new Branch;
    this.FormNew = !this.FormNew;
  }

  add() {
    this.cleanMessage();
    if (this.NewElement) {
      this.saveElement.push(this.NewElement);
      this.branchService.saveBranches(this.saveElement)
        .subscribe(res => {
          this.List.push(this.NewElement);
          this.List.sort((a, b) => a.idBranch < b.idBranch ? -1 : a.idBranch > b.idBranch ? 1 : 0);
          this.FormNew = false;
          this.message = "Elemento agregado correctamente";
          setTimeout(() => {
            this.message = "";
          }, 7000);
        }, err => {
          this.error = err;
          this.cleanError();
        });
    }
  }

  cleanError() {
    setTimeout(() => {
      this.error = "";
    }, 7000);
  }

  changeValue(idBranch: any) {
    this.cleanMessage();
    let name = "[date-branch ='" + idBranch + "']";
    document.querySelectorAll(name).forEach(function (element) {
      element.removeAttribute("readonly");
    })
    document.getElementsByName("btgrnoffice-" + idBranch)[0].removeAttribute("hidden");

    document.getElementsByName("btednoffice-" + idBranch)[0].setAttribute("hidden", "hidden");
  }

  updateList(idBranch: any) {
    this.cleanMessage();
    let name = "[date-branch = '" + idBranch + "']";
    document.querySelectorAll(name).forEach(function (element) {
      element.setAttribute("readonly", "readonly");
    });

    //console.log(this.List.find(t => t.idOffice == idOffice));

    this.branchService.updateBranch(this.List.find(t => t.idBranch == idBranch))
      .subscribe(res => {
        document.getElementsByName("btednoffice-" + idBranch)[0].removeAttribute("hidden");
        document.getElementsByName("btgrnoffice-" + idBranch)[0].setAttribute("hidden", "hidden");
      }, err => this.error = err)
  }

}
